import React from "react";
import ImageUploader from '../../../components/react-images-upload/index';
import {injectIntl} from 'react-intl';
import i18n from "../../../main/i18n"

export default injectIntl((props) => {
  const msg = i18n.getMsg(props.intl);

  const onChange = (fileWrappers) => {
    props.onChange(fileWrappers.map(fw => fw.dataURL));
  };

  return (
    <ImageUploader
      withIcon
      onChange={onChange}
      imgExtension={['.jpg', '.jpeg', '.png']}
      buttonText={msg('addImages')}
      buttonType="button"
      maxFileSize={10 * 1024 * 1024}
      labelClass='hidden'
      errorClass='text-danger'
      withPreview
      fileSizeError={msg('imageUpload.fileSizeError')}
      fileTypeError={msg('imageUpload.fileTypeError')}/>
  );
})
